import Request from '../util/request'
const path = "eip-mapp-sapwms-server/"
// const path = "sapwms-api/"

export function unLockOrModifyPwd(data) {
    return Request({
      url: path + 'sapUser/unLockOrModifyPwd',
      method: 'post',
      data
    })
  }
